import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function ElectricalServiceRequestForm() {
  return <ServiceRequestForm serviceType="ElectricalService" title="Electrical" />;
}

